module.exports = __webpack_public_path__ + "static/media/logout.41d4fd75.svg";